import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

export default function Footer() {
  return (
    <Container maxWidth="lg" sx={{ py: { xs: 7, md: 9 } }}>
      <Box
        sx={(theme) => ({
          borderRadius: { xs: 4, md: 5 },
          border: "1px solid",
          borderColor:
            theme.palette.mode === "dark"
              ? "rgba(87, 137, 184, 0.40)"
              : "primary.light",
          background:
            theme.palette.mode === "dark"
              ? "linear-gradient(135deg, rgba(8,18,30,0.98), rgba(12,31,48,0.96) 55%, rgba(14,39,61,0.92))"
              : "linear-gradient(135deg, rgba(4,18,37,0.98), rgba(7,37,64,0.96) 55%, rgba(10,53,88,0.92))",
          p: { xs: 3, md: 5 },
          color: theme.palette.mode === "dark" ? "#D8E9F8" : "#EAF7FF",
          position: "relative",
          overflow: "hidden",
        })}
      >
        <Box
          sx={(theme) => ({
            position: "absolute",
            inset: 0,
            background:
              theme.palette.mode === "dark"
                ? "radial-gradient(circle at 12% 22%, rgba(61, 145, 201, 0.24), rgba(11,32,50,0) 45%), radial-gradient(circle at 88% 82%, rgba(78, 149, 210, 0.2), rgba(11,32,50,0) 40%)"
                : "radial-gradient(circle at 12% 22%, rgba(96, 205, 255, 0.23), rgba(8,35,58,0) 45%), radial-gradient(circle at 88% 82%, rgba(126, 211, 255, 0.2), rgba(8,35,58,0) 40%)",
          })}
        />

        <Stack spacing={2.5} sx={{ position: "relative" }}>
          <Typography
            variant="h4"
            sx={{ color: "#FFFFFF", fontSize: { xs: "1.5rem", md: "2rem" } }}
          >
            Pronto para levar sua operacao de quadras a um novo nivel?
          </Typography>
          <Typography sx={{ color: "rgba(230,244,255,0.86)", maxWidth: 760 }}>
            Centralize agenda, mensalistas e financeiro em uma plataforma unica,
            com experiencia premium para sua equipe e seus clientes.
          </Typography>
          <Stack direction={{ xs: "column", sm: "row" }} spacing={1.2}>
            <Button variant="contained" color="primary" href="/register">
              Criar conta gratuita
            </Button>
            <Button
              variant="outlined"
              href="/login"
              sx={(theme) => ({
                borderColor:
                  theme.palette.mode === "dark"
                    ? "rgba(92, 153, 202, 0.58)"
                    : "rgba(124, 232, 255, 0.55)",
                color: theme.palette.mode === "dark" ? "#CFE4F8" : "#DDF8FF",
                "&:hover": {
                  backgroundColor:
                    theme.palette.mode === "dark"
                      ? "rgba(92, 153, 202, 0.15)"
                      : "rgba(124, 232, 255, 0.12)",
                },
              })}
            >
              Ja tenho conta
            </Button>
          </Stack>
        </Stack>
      </Box>

      <Divider sx={{ my: 3.5 }} />

      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={1}
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", sm: "center" }}
      >
        <Typography variant="body2" color="text.secondary">
          © {new Date().getFullYear()} Alttime. Todos os direitos reservados.
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Desenvolvido para gestao esportiva profissional.
        </Typography>
      </Stack>
    </Container>
  );
}
